import React from 'react';
import { Button } from '@cp/ds/src/components/button';
import { Stack } from '@cp/ds/src/components/stack';
import { ChevronRightIcon } from '@cp/ds/src/icons';
import { Trademark } from '@cp/ds/src/components/trademark';
import { RoutedLink as Link } from 'src/shared/ui/link';
import { BurgerMenuButton } from 'src/features/burgerMenu';
import { LoginButton } from 'src/features/auth';
import { CitiesListLink, CitySelectionButton } from 'src/features/location';
import { HeaderFeature } from '../model';
import { HeaderContentProps } from './model';

export const HeaderContentMobile: React.FC<HeaderContentProps> = ({
  features,
  trademarkSize,
  onGoBack,
  onLogoClick,
  clientProfile,
  rightBlock,
  leftBlock,
  logo,
}) => {
  return (
    <>
      <Stack alignItems="center" direction="row">
        {features[HeaderFeature.GoBack] && onGoBack ? (
          <Button onClick={onGoBack} size="small" square sx={{ ml: -1, mr: 0.5 }} variant="text">
            <ChevronRightIcon sx={{ transform: 'rotate(180deg)', fontSize: '1.75rem' }} />
          </Button>
        ) : null}
        {logo && (
          <Link disableHover onClick={onLogoClick} underline={false}>
            {/* eslint-disable-next-line @typescript-eslint/no-magic-numbers */}
            <Trademark size={trademarkSize ?? 2.109375} />
          </Link>
        )}

        {features[HeaderFeature.CitiesList] ? <CitiesListLink /> : null}
        {features[HeaderFeature.CitySelection] ? <CitySelectionButton /> : null}
        {leftBlock}
      </Stack>
      {rightBlock}
      {features[HeaderFeature.LoginButton] && !clientProfile ? <LoginButton /> : null}
      {features[HeaderFeature.BurgerMenu] ? <BurgerMenuButton /> : null}
    </>
  );
};
